import axios from "axios";

class searchClient {


  constructor(settings) {
    this.settings = Object.assign({
      host: null
    }, settings)
    
  }
  search(query) {
    return axios.post(this.settings.host, {query })
  }



}

export default searchClient;
